import React from "react";
import "./SummitObjectivesNew.scss";

const SummitObjectivesNew = () => {
  const objectives = [
    {
      number: "01",
      badgeColor: "#F2BC00",
      iconColor: "#F2BC00",
      icon: "fa fa-user",
      title: "Empower 1M Business Owners",
      description:
        "Equip one million entrepreneurs with advanced cash flow strategies to achieve sustainable business growth",
    },
    {
      number: "02",
      badgeColor: "#8956B3",
      iconColor: "#8956B3",
      icon: "fa fa-users",
      title: "Enable Investor Partnerships",
      description:
        "Create a platform for direct investor-business partnerships to fuel growth and innovation.",
    },
    {
      number: "03",
      badgeColor: "#F97D7F",
      iconColor: "#F97D7F",
      icon: "fa fa-line-chart",
      title: "Showcase Scalable Models",
      description:
        "Highlight proven business models that demonstrate exceptional cash flow management principles.",
    },
    {
      number: "04",
      badgeColor: "#7DC370",
      iconColor: "#7DC370",
      icon: "fa fa-globe",
      title: "Position India as Cash Flow Hub",
      description:
        "Establish India as a global leader in cash flow innovation and financial strategy development.",
    },
  ];

  return (
    <section className="summit-objectives-new-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="section-heading-new"
              style={{ textAlign: "center", marginBottom: "40px" }}
            >
              <h2
                style={{
                  display: "inline-block",
                  margin: 0,
                  color: "#FFFFFF",
                  fontSize: "36px",
                }}
              >
                What We Aim To Achieve At Cash Flow Summit 2026 ?
              </h2>
            </div>
            <div className="objectives-grid-new">
              {objectives.map((objective, index) => (
                <div key={index} className="objective-card-new">
                  {/* Number Badge */}
                  <div
                    className="number-badge-new"
                    style={{ background: objective.badgeColor }}
                  >
                    {objective.number}
                  </div>

                  {/* Icon */}
                  <div className="icon-wrapper-new">
                    <i
                      className={objective.icon}
                      style={{ color: objective.iconColor }}
                    ></i>
                  </div>

                  {/* Title */}
                  <h3 className="objective-title-new">{objective.title}</h3>

                  {/* Description */}
                  <p className="objective-description-new">
                    {objective.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SummitObjectivesNew;
